(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["itp-form"] && !Shopify.designMode) return;
  try {
    
  function inthatpackPrefillNomination() {
    const selectedType = new URLSearchParams(window.location.search).get('type');
    if (selectedType !== 'business' && selectedType !== 'professional') return;
    document.querySelectorAll('[data-itp-form-section] [data-nominee-type]').forEach((select) => {
      if (select.value === '') select.value = selectedType;
    });
  }
  inthatpackPrefillNomination();
  document.addEventListener('shopify:section:load', inthatpackPrefillNomination);

  } catch(e) { console.error(e); }
})();
})();
